import AddressAPIRequest from "_shared/addresses/_api/commands/address-api-command.";
import Company from "marketplace/companies/company";

export default class MarketplaceCompanyAPIRequest {
  public name: string;
  public yearEstablished?: number;
  public numberOfEmployees?: number;
  public description?: string;
  public address?: AddressAPIRequest;
  public website?: string;
  public categories: string[] = [];
  public isVisible: boolean;
  public contactId?: string;

  public constructor(company: Company) {
    if (!company.profile?.name) throw new Error("Company name is required");
    this.name = company.profile.name;
    this.yearEstablished = company.profile.yearEstablished;
    this.numberOfEmployees = company.profile.numberOfEmployees;
    this.description = company.profile.description;
    this.address = company.profile.location ? new AddressAPIRequest(company.profile.location) : undefined;
    this.website = company.profile.website?.toString();
    this.categories = company.profile.categories;
    this.isVisible = company.isVisible;
    this.contactId = company.contactId?.value;
  }
}
